import React, { useState, useEffect } from 'react';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { SelectPropTypes, SelectDefaultValues } from './select-V2.prop-types';
import { Container, SelectLabel, StyledSelect, Hint, Optionals, Opts, ArrowIcon, SelectIcon } from './Select.styled';
import Opt from './components/OptionV2';
export const SelectV2 = props => {
    const [selected, setSelectedState] = useState(props.val || '');
    const onChange = (val) => {
        setSelectedState(val);
        props.onChanged && props.onChanged(val);
    };
    // Handle value prop change
    useEffect(() => {
        setSelectedState(props.val || '');
    }, [props.val]);
    /**
     * This code is the same in Original Select
     * !important, here extract the all properties and render in Select
     * TODO: Refactor the @ts-igonore
     */
    const options = React.Children.map(props.children, child => {
        //@ts-ignore
        return React.cloneElement(child, {
        //@ts-ignore
        });
    });
    return (React.createElement(Container, { width: props.width ? props.width : undefined },
        React.createElement(ArrowIcon, { icon: faChevronDown, disabled: props.disabled }),
        !props.hideIcon && React.createElement(SelectIcon, { disabled: props.disabled || undefined, icon: props.icon || faMapMarkerAlt }),
        React.createElement(StyledSelect, { isInvalid: props.isInvalid || false, onChange: val => onChange(val.target.value), value: selected, disabled: props.disabled || undefined },
            React.createElement("option", { disabled: true, value: "defaultValue" }, props.placeholder),
            options),
        !props.noLabel && (React.createElement(SelectLabel, { hidden: selected !== '' }, props.label)),
        (props.hint || props.optional) && (React.createElement(Optionals, null,
            React.createElement(Hint, null, props.hint),
            React.createElement(Opts, null, props.optional)))));
};
SelectV2.defaultProps = SelectDefaultValues;
SelectV2.propTypes = SelectPropTypes;
export const OptionV2 = Opt;
//# sourceMappingURL=SelectV2.js.map